import { useQuery } from "@tanstack/react-query";
import { queryCommonFlags } from "@/api/constants";
import { getOwnerIds } from "../../api/owner-ids";

const useOwnerIds = ({ customerUid }: { customerUid?: string }) => {
  const query = useQuery({
    queryKey: ["owner-ids", customerUid],
    queryFn: () => getOwnerIds(customerUid || ""),
    enabled: !!customerUid,
    ...queryCommonFlags,
  });

  return {
    ...query,
    data: query.data?.data,
  };
};

export default useOwnerIds;
